<template>
  <div class="modal">
    <div @click="handleClickSelectAndCopy">{{ key }}</div>
    <template v-for="lang in langs">
      <div class="type" :key="`type-${lang}`">{{ langsMapping[lang] }}</div>
      <textarea
        :key="`input-${lang}`"
        type="text"
        v-model="langValues[lang]"
        @keypress.enter.prevent
        :placeholder="`請輸入${langsMapping[lang]}`"
      />
    </template>

    <div class="btns">
      <div @click="handleClickDelete" class="btn btn-delete">刪除</div>
      <div @click="handleClickClose" class="btn btn-close">取消</div>
      <div @click="handleClickUpdate" class="btn btn-update">更新</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Modal',
  components: {},
  data() {
    return {
      id: null,
      key: '',
      langValues: {},
    }
  },
  created() {
    this.langs.forEach((lang) => {
      this.$set(this.langValues, lang, '')
    })
  },
  computed: {
    ...mapGetters(['data', 'idModal', 'langs', 'langsMapping']),
  },
  watch: {
    idModal() {
      const obj = this.data.find((obj) => obj.id === this.idModal)
      if (obj) {
        this.id = obj.id
        this.key = obj.key
        this.langs.forEach((lang) => {
          this.$set(this.langValues, lang, obj[lang] || '')
        })
      }
    },
  },
  methods: {
    handleClickDelete() {
      if (window.confirm(`確定刪除 ${this.key} ？`)) {
        this.$store.dispatch('deleteData', { id: this.id })
        this.handleClickClose()
      }
    },
    handleClickClose() {
      this.$store.commit('setIsModal', false)
    },
    handleClickUpdate() {
      if (this.langValues['zh_CN'].trim() !== '') {
        const body = {}
        this.langs.forEach((lang) => {
          body[lang] = this.langValues[lang].trim()
        })
        this.$store.dispatch('updateData', { id: this.id, body })
      }
    },
    handleClickSelectAndCopy(e) {
      // IE
      if (document.body.createTextRange) {
        const range = document.body.createTextRange()
        range.moveToElementText(e.target)
        range.select()
      } else if (window.getSelection) {
        const selection = window.getSelection()
        const range = document.createRange()
        range.selectNodeContents(e.target)
        selection.removeAllRanges()
        selection.addRange(range)
      }
      document.execCommand('copy')
      this.$store.dispatch('handleMessage', {
        success: true,
        text: '已複製到剪貼簿',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.modal {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1;
  padding: 0.5rem;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
  div,
  textarea {
    width: 100%;
    padding: 5px;
    margin: 0.25rem 0;
    font-size: 1.2rem;
    overflow-wrap: break-word;
    @media screen and (min-width: 768px) {
      padding: 2px;
    }
  }
  .btns {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .btn {
      width: 25%;
      height: 30px;
      padding: 2px;
      margin: 0.25rem 0;
      font-size: 1.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      &.btn-delete {
        color: #fff;
        background-color: #db2828;
        border-color: #db2828;
        user-select: none;
      }
      &.btn-close {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
        user-select: none;
      }
      &.btn-update {
        color: #fff;
        background-color: #21ba45;
        border-color: #21ba45;
        user-select: none;
      }
    }
  }
  .type {
    font-size: 1rem;
    margin: 0;
    padding-bottom: 0;
  }
  @media screen and (min-width: 768px) {
    display: none;
  }
}
</style>
